// About-page FAQ — focuses on Siddhivinayak Group's credibility,
// leadership, and heritage. Different from the homepage brand-FAQ to
// avoid duplicate-content signals across pages while reinforcing the
// About page's E-E-A-T role.
const aboutFaq = [
  {
    question: "Who founded Siddhivinayak Group?",
    answer:
      "Dr. Kunal G. Padole, an MBA and Ph.D. in Management, founded Siddhivinayak Infrastructure — the venture behind Siddhivinayak Group. With 16+ years of entrepreneurial leadership across real estate, education, and social sectors, he continues to drive the group's expansion across Central India.",
  },
  {
    question: "How many years of experience does Siddhivinayak Group have?",
    answer:
      "Siddhivinayak Group has 16+ years of experience in Nagpur's real estate market, with completed and under-construction projects spanning premium apartments, plotted developments, and townships. The group has positively impacted lakhs of lives through its education and social initiatives alongside real estate.",
  },
  {
    question: "What is the relationship between Siddhivinayak Group and Kunal Padole Group?",
    answer:
      "Siddhivinayak Group is a distinguished real-estate venture of the Kunal Padole Group. The parent group operates across real estate, education, and social initiatives, while Siddhivinayak Group focuses exclusively on residential and plotted developments in Nagpur and Central India.",
  },
  {
    question: "What is Siddhivinayak Group's mission and vision?",
    answer:
      "The group's mission is to deliver premium residential projects that combine quality construction, transparent dealings, and long-term investment value. Its vision is to be Nagpur's most trusted real estate developer — one that contributes to the city's transformation into a world-class Smart City while maintaining the highest standards of customer trust.",
  },
  {
    question: "What awards or recognitions has Siddhivinayak Group received?",
    answer:
      "Siddhivinayak Group has earned recognition through MahaRERA registration (P50500078967 for Hilltop Heights -14), repeat-customer referrals that drive over 40% of new sales, and consistent delivery of projects on or ahead of RERA-stipulated timelines. Customer testimonials are published on the official website and updated quarterly.",
  },
  {
    question: "How does Siddhivinayak Group ensure construction quality?",
    answer:
      "Quality is enforced through three layers: (1) material testing at certified third-party labs, (2) on-site engineers present at every pour with stage-wise checklists, and (3) independent structural audits at slab-level milestones. The group uses branded cement, BIS-certified steel, and branded lift / electrical fittings across all residential projects.",
  },
  {
    question: "Does Siddhivinayak Group have an in-house team or outsource construction?",
    answer:
      "Siddhivinayak Group runs an integrated model: design and project management are handled by the in-house team led by the founder, while construction is executed through a small set of long-term contractor partners who have delivered 3+ projects with the group. This balance keeps accountability in-house and execution scalable.",
  },
  {
    question: "Where is Siddhivinayak Group headquartered?",
    answer:
      "The registered office is at No. 1/3/731, Raje Raghuji Nagar, opposite Kamala Nehru College, Nagpur 440009. Site offices are also maintained at each active project — Hilltop Heights -14, Hilltop Heights -11, Embassy-10, Siddhivinayak Nagari, and Ayodhya City — for on-ground customer service.",
  },
];

export default aboutFaq;